var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"content-wrapper"},[_c('div',{staticClass:"content-title"},[_vm._v("购物车")]),_c('PurchaseSteps',{attrs:{"cur-step":0}}),_c('CartView',{attrs:{"cart-list":_vm.cartList,"cooler-gift-qty":_vm.coolerGiftQty}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }